"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
const paragraph_1 = require("./paragraph");
class BlockQuote extends index_1.TopLevelNode {
    constructor() {
        super(...arguments);
        this.content = new index_1.ContentNode('blockquote');
    }
    paragraph() {
        return this.content.add(new paragraph_1.Paragraph());
    }
    toJSON() {
        return this.content.toJSON();
    }
}
exports.BlockQuote = BlockQuote;
//# sourceMappingURL=block-quote.js.map